import { createContext } from "react";

export interface IStateContext<T extends unknown> {
  add?(item: T, isFirst: boolean): void;
  update?(item?: T, shouldRevalidate?: boolean);
}

const StateContext = createContext<IStateContext<unknown>>({});

export default StateContext;
